import {Component, Input, OnInit} from '@angular/core';
import {Moment} from 'moment';

@Component({
    selector: 'app-datetime-summary-field',
    templateUrl: './datetime-summary-field.component.html',
})
export class DatetimeSummaryFieldComponent implements OnInit {

    @Input() datetime: Moment;
    @Input() label: string;

    constructor() {
    }

    ngOnInit() {
    }

}
